export class PricingCard {
	id: number;
	productId: number;
	superhogUserId?: string | null;
	currencyId: number;
	pricingCardTypeId: number;
	petProtectionScopeId?: number | null;
	amount: number;
	startDate: Date | string;
	endDate?: Date | string | null;
	createdDate: Date | string;
	updatedDate?: Date | string | null;
}
